import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { IdentityService } from '../services/identity';

export const matchSignedInUser: CanMatchFn = () => inject(IdentityService).isSignedIn();
